import React from "react";
import {useAuth} from "./UseAuthHook";
import {Navigate, useLocation} from "react-router-dom";
import {Flex, Loader, Stack, Text} from "@mantine/core";

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({children}) => {
    const {isAuthenticated, loading} = useAuth();
    const location = useLocation();

    console.log("from protected routes..", isAuthenticated, loading);
    if (loading) {
        return (
        <Flex h="100vh" align="center" justify="center">
            <Stack justify="center" align="center">
                <Loader/>
                <Text>Completing authentication...</Text>
            </Stack>
        </Flex>);
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{from: location}} replace/>;
    }

    return <>{children}</>;
};